import getApiClient from '@/plugins/api-client'

export default {
    login: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.loginErrorMessage = null

        api.post('auth', {
            username: `a:${self.username}`,
            password: self.password
        })
            .then((response) => {
                let data = response.data
                self.$store.commit('setSessionToken', data.token)
                self.$store.commit('setSessionRefreshToken', data.refresh_token)

                self.$router.push('/dashboard')
            })
            .catch((error) => {
                switch(error.response.status) {
                    case 401:
                        self.loginErrorMessage = error.response.data.message
                        break;
                    default:
                        self.loginErrorMessage = 'Não foi possível fazer login no momento.'
                        break;
                }
            })
    }
}
